let jjpj = {
  jindexname: "",
  projectName: "",
  total: 0,
  基础数据: {
    projectName: "",
    calculationPeriod: 15,
    constructionPeriod: 1,
    operationPeriod: 14,
    normalYear: 1,
    loadData: {
      1: 0,
      2: 100,
      3: 100,
      4: 100,
      5: 100,
      6: 100,
      7: 100,
      8: 100,
      9: 100,
      10: 100,
      11: 100,
      12: 100,
      13: 100,
      14: 100,
      15: 100,
    },
    discountRate: 10,
  },
  总投资估算: {
    总表: {
      基本预备费率: 5,
      涨价预备费率: 0,
      总投资: {
        建筑费用: 0,
        设备费用: 0,
        安装费用: 0,
        其他费用: 0,
        合计: 0,
        比例: 0,
      },
      建设投资: {
        建筑费用: 0,
        设备费用: 0,
        安装费用: 0,
        其他费用: 0,
        合计: 0,
        比例: 0,
        工程费用: {
          建筑费用: 0,
          设备费用: 0,
          安装费用: 0,
          其他费用: 0,
          合计: 0,
          比例: 0,
        },
        工程建设其他费用: {
          建筑费用: 0,
          设备费用: 0,
          安装费用: 0,
          其他费用: 0,
          合计: 0,
          比例: 0,
        },
        预备费: {
          建筑费用: 0,
          设备费用: 0,
          安装费用: 0,
          其他费用: 0,
          合计: 0,
          比例: 0,
          基本预备费: {
            建筑费用: 0,
            设备费用: 0,
            安装费用: 0,
            其他费用: 0,
            合计: 0,
            比例: 0,
          },
          涨价预备费: {
            建筑费用: 0,
            设备费用: 0,
            安装费用: 0,
            其他费用: 0,
            合计: 0,
            比例: 0,
          },
        },
      },
      流动资金: {
        建筑费用: 0,
        设备费用: 0,
        安装费用: 0,
        其他费用: 0,
        合计: 0,
        比例: 0,
      },
      建设期利息: {
        建筑费用: 0,
        设备费用: 0,
        安装费用: 0,
        其他费用: 0,
        合计: 0,
        比例: 0,
      },
    },
    建筑费用: {
      合计: 0,
      tableData: [],
    },
    设备工程: {
      购置费合计: 0,
      运输费合计: 0,
      安装费合计: 0,
      合计: 0,
      tableData: [],
    },
    工程建设其他费用: {
      合计: 0,
      data: {
        无形资产: [
          {
            id: 0,
            name: "土地费用",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "知识产权/技术成果",
            basis: "",
            amount: 0,
            sequence: 0,
          },
        ],
        其他资产: [
          {
            id: 0,
            name: "建设单位管理费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "生产准备费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "勘察设计费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "临时设施费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "招标代理费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "工程保险费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "工程咨询服务费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
          {
            id: 0,
            name: "其他估价咨询费",
            basis: "",
            amount: 0,
            sequence: 0,
          },
        ],
      },
    },
  },
  资金筹措及分年投资计划: {
    资金筹措: {
      amount: 0,
      proportion: 0,
      项目资本金: {
        amount: 0,
        proportion: 20,
      },
      债务资金: {
        amount: 0,
        proportion: 0,
        interest: 0,
        loan: [0, 0, 0],
        interestlist: [0, 0, 0],
        operating: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        principal: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        银行借款: {
          amount: 0,
          proportion: 0,
          term: 1,
          rate: 4.35,
          startyear: 1, //
          quarter: 3, //
          interest: 0,
          loan: [0, 0, 0],
          interestlist: [0, 0, 0],
          operating: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          Repayment: "逐年付息期末还本",
          principal: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        债券: {
          amount: 0,
          proportion: 0,
          term: 1,
          rate: 4.5,
          startyear: 1,
          quarter: 3,
          interest: 0,
          loan: [0, 0, 0],
          interestlist: [0, 0, 0],
          operating: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          Repayment: "逐年付息期末还本",
          principal: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        融资租赁: {
          amount: 0,
          proportion: 0,
          term: 1,
          rate: 5.0,
          startyear: 1,
          quarter: 3,
          interest: 0,
          loan: [0, 0, 0],
          interestlist: [0, 0, 0],
          operating: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          Repayment: "逐年付息期末还本",
          principal: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        其他借款: {
          amount: 0,
          proportion: 0,
          term: 1,
          rate: 5.0,
          startyear: 1,
          quarter: 3,
          interest: 0,
          loan: [0, 0, 0],
          interestlist: [0, 0, 0],
          operating: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          Repayment: "逐年付息期末还本",
          principal: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      },
    },
    还本付息: {
      repaymentSource: "netProfit",
      repaymentData: {},
      addedFunds: {},
    },
    分年投资计划: {
      参数: {
        constructionPeriod: 0,
        fullLoadYear: 0,
      },
      总投资: {
        year: [0, 0, 0, 0],
        amount: 0,
        建设投资: {
          year: [0, 0, 0, 0],
          amount: 0,
        },
        建设期利息: {
          year: [0, 0, 0],
          amount: 0,
        },
        流动资金: {
          year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          amount: 0,
        },
      },
      资金筹措: {
        year: [0, 0, 0, 0],
        amount: 0,
        资本金: {
          year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          amount: 0,
          建设投资: {
            year: [0, 0, 0],
            amount: 0,
          },
          建设期利息: {
            year: [0, 0, 0],
            amount: 0,
          },
          流动资金: {
            year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
            amount: 0,
          },
        },
        债务资金: {
          year: [0, 0, 0, 0],
          amount: 0,
          loan: [],
          建设投资: {
            year: [0, 0, 0],
            amount: 0,
          },
          流动资金: {
            year: [0, 0, 0, 0],
            amount: 0,
          },
        },
      },
    },
  },
  成本费用: {
    原辅材料: {
      materials: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        materialslist: [],
        total: 0,
      },
      auxiliary: {
        taxRate: 0.13,
        unitPrice: 0,
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
        taxTotal: 0,
      },
      other: {
        taxRate: 0.13,
        unitPrice: 0,
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
        taxTotal: 0,
      },
      total: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        tax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
        taxTotal: 0,
      },
    },
    燃料动力: {
      total: {
        year: [],
        tax: [],
        total: 0,
        taxTotal: 0,
      },
      fuelpower: [],
    },
    职工薪酬: {
      wages: [],

      total: {
        total: 0,
        salaryTotal: 0,
        avgSalaryTotal: 0,
        welfareTotal: 0,
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        salaryYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        avgSalaryYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        welfareYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        gzfltotal: 0,
        gzfl: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      welfareList: [],
    },
    折旧: {
      categories: {
        房屋及建构筑物: {
          originalValue: 0,
          depreciationYears: 20,
          salvageRate: 4,
          depreciationTotal: 0,
          NAVatEOP: 0,
          originalValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          depreciationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          currentValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        设备: {
          originalValue: 0,
          depreciationYears: 10,
          salvageRate: 0,
          depreciationTotal: 0,
          NAVatEOP: 0,
          originalValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          depreciationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          currentValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      },
      total: {
        depreciationTotal: 0,
        NAVatEOP: 0,
        originalValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        depreciationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        currentValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    },
    摊销: {
      categories: {
        无形资产: {
          originalValue: 0,
          depreciationYears: 10,
          depreciationTotal: 0,
          NAVatEOP: 0,
          originalValues: [],
          depreciationValues: [],
          currentValues: [],
        },
        其他资产: {
          originalValue: 0,
          depreciationYears: 5,
          depreciationTotal: 0,
          NAVatEOP: 0,
          originalValues: [],
          depreciationValues: [],
          currentValues: [],
        },
      },
      total: {
        depreciationTotal: 0,
        NAVatEOP: 0,
        originalValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        depreciationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        currentValues: [],
        amortizationTotal: 0,
        amortizationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
      items: {
        无形资产: {
          originalValue: 0,
          amortizationYears: 10,
          amortizationTotal: 0,
          originalValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          amortizationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
        其他资产: {
          originalValue: 0,
          amortizationYears: 5,
          amortizationTotal: 0,
          originalValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
          amortizationValues: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        },
      },
    },
    修理费: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    其他费用: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    利息: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    经营成本: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    固定成本: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    可变成本: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
    总成本费用: {
      total: 0,
      year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    },
  },
  营业收入税金及利润: {
    营业收入及营业税金: {
      consumptiontax: 0,
      UMCTax: 7,
      Educationtax: 3,
      revenuetotal: 0,
      revenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      alltax: 0,
      additionaltax: 0,
      additionaltaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      alltaxByYear: [],
      outputtotal: 0,
      inptotal: 0,
      valudedtotal: 0,
      UMCTaxTotal: 0,
      EducationtaxTotal: 0,
      consumptiontaxTotal: 0,
      outputtaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      inputtaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      valueddedtax: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      UMCTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      EducationtaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      consumptiontaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      revenue: {
        revenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        revenuetotal: 0,
        revenuelist: [],
      },
      otherinput: {
        input: 0,
        tax: 0,
        total: 0,
        taxTotal: 0,
        taxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        inputByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      },
    },
    利润: {
      incomeTaxRate: 25,
      法定盈余公积金Rate: 0,
      任意盈余公积金Rate: 0,
      subsidyIncome: 0,
      total: 0,
      netProfit: 0,
      netProfitYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      incomeTaxTotal: 0,
      preferredStockRate: 0,
      year: [],
      incomeTaxYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      法定盈余公积金Total: 0,
      任意盈余公积金Total: 0,
      法定盈余公积金Year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      任意盈余公积金Year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      revenueTotal: 0,
      revenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      businessTaxTotal: 0,
      businessTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      vatTotal: 0,
      vatByYear: [],
      totalCostTotal: 0,
      totalCostByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      subsidyIncomeTotal: 0,
      subsidyIncomeByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      profitBeforeTaxTotal: 0,
      profitBeforeTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      lossCompensationTotal: 0,
      lossCompensationByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      taxableIncomeTotal: 0,
      taxableIncomeByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      undistributedProfitTotal: 0,
      undistributedProfitByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      ebitTotal: 0,
      ebitByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      ebitdaTotal: 0,
      ebitdaByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      ytaxableIncomeTotal: 0,
      ytaxableIncomeByYear: [],
      beginningUndistributedProfitTotal: 0,
      beginningUndistributedProfitByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      availableForDistributionTotal: 0,
      availableForDistributionByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      availableForInvestorsTotal: 0,
      availableForInvestorsByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      preferredStockDividendTotal: 0,
      preferredStockDividendByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      commonDividendTotal: 0,
      commonDividendByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      preferredStockDividendRate: 0,
    },
  },
  盈利能力分析: {
    projectIRR: null,
    capitalIRR: null,
    netPresentValue: null,
    paybackPeriod: null,
    detailedTableData: [],
    全部投资现金流量: {
      operatingCashInflowByYear: [],
      operatingCashInflowTotal: 0,
      operatingRevenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingRevenueTotal: 0,
      subsidyIncomeByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      subsidyIncomeTotal: 0,
      operatingOtherCashInflowByYear: [],
      operatingOtherCashInflowTotal: 0,
      operatingCashOutflowByYear: [],
      operatingCashOutflowTotal: 0,
      operatingCostByYear: [],
      operatingCostTotal: 0,
      salesTaxByYear: [],
      salesTaxTotal: 0,
      vatByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      vatTotal: 0,
      incomeTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      incomeTaxTotal: 0,
      operatingOtherCashOutflowByYear: [],
      operatingOtherCashOutflowTotal: 0,
      operatingNetCashFlowByYear: [],
      operatingNetCashFlowTotal: 0,
      investmentCashInflowByYear: [],
      investmentCashInflowTotal: 0,
      investmentCashOutflowByYear: [],
      investmentCashOutflowTotal: 0,
      constructionInvestmentByYear: [],
      constructionInvestmentTotal: 0,
      operationMaintenanceInvestmentByYear: [],
      operationMaintenanceInvestmentTotal: 0,
      workingCapitalByYear: [],
      workingCapitalTotal: 0,
      investmentOtherCashOutflowByYear: [],
      investmentOtherCashOutflowTotal: 0,
      investmentNetCashFlowByYear: [],
      investmentNetCashFlowTotal: 0,
      financingCashInflowByYear: [],
      financingCashInflowTotal: 0,
      equityInvestmentByYear: [],
      equityInvestmentTotal: 0,
      constructionLoanByYear: [],
      constructionLoanTotal: 0,
      workingCapitalLoanByYear: [],
      workingCapitalLoanTotal: 0,
      bondByYear: [],
      bondTotal: 0,
      shortTermLoanByYear: [],
      shortTermLoanTotal: 0,
      financingOtherCashInflowByYear: [],
      financingOtherCashInflowTotal: 0,
      financingCashOutflowByYear: [],
      financingCashOutflowTotal: 0,
      interestExpenseByYear: [],
      interestExpenseTotal: 0,
      debtPrincipalRepaymentByYear: [],
      debtPrincipalRepaymentTotal: 0,
      dividendsByYear: [],
      dividendsTotal: 0,
      financingOtherCashOutflowByYear: [],
      financingOtherCashOutflowTotal: 0,
      financingNetCashFlowByYear: [],
      financingNetCashFlowTotal: 0,
      netCashFlowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      netCashFlowTotal: 0,
      netCashFlowBeforeTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      cumulativeSurplusFundByYear: [],
      cumulativeSurplusFundTotal: 0,
      discountedNetCashFlowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      discountedNetCashFlowTotal: 0,
      discountedNetCashFlowBeforeTaxByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      discountedNetCashFlowTotalBeforeTax: 0,
      cumulativeDiscountedNetCashFlowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      cumulativeDiscountedNetCashFlowBeforeTaxByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      irr: 0,
      irrBeforeTax: 0,
      paybackPeriod: 0,
      paybackPeriodBeforeTax: 0,
      discountedPaybackPeriod: 0,
      discountedPaybackPeriodBeforeTax: 0,
      totalInvestmentByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      totalInvestmentTotal: 0,
      recoveryFixedAssetsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      recoveryFixedAssetsTotal: 0,
      recoveryWorkingCapitalByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      recoveryWorkingCapitalTotal: 0,
      totalCashInflowsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      totalCashInflowsTotal: 0,
      operatingCostsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingCostsTotal: 0,
      businessTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      businessTaxTotal: 0,
      totalCashOutflowsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      totalCashOutflowsTotal: 0,
    },
    资本金现金流量表: {
      cashInflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      cashInflowTotal: 0,
      operatingRevenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingRevenueTotal: 0,
      subsidyIncomeByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      subsidyIncomeTotal: 0,
      recoveryFixedAssetsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      recoveryFixedAssetsTotal: 0,
      recoveryWorkingCapitalByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      recoveryWorkingCapitalTotal: 0,
      otherCashInflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      otherCashInflowTotal: 0,
      cashOutflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      cashOutflowTotal: 0,
      equityInvestmentByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      equityInvestmentTotal: 0,
      debtPrincipalRepaymentByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      debtPrincipalRepaymentTotal: 0,
      interestExpenseByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      interestExpenseTotal: 0,
      operatingCostByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingCostTotal: 0,
      salesTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      salesTaxTotal: 0,
      vatByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      vatTotal: 0,
      incomeTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      incomeTaxTotal: 0,
      otherCashOutflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      otherCashOutflowTotal: 0,
      netCashFlowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      netCashFlowTotal: 0,
      netCashFlowBeforeTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      cumulativeNetCashFlowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      cumulativeNetCashFlowBeforeTaxByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      discountedNetCashFlowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      discountedNetCashFlowTotal: 0,
      discountedNetCashFlowBeforeTaxByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      discountedNetCashFlowBeforeTaxTotal: 0,
      cumulativeDiscountedNetCashFlowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      cumulativeDiscountedNetCashFlowBeforeTaxByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      irr: 0,
      irrBeforeTax: 0,
      paybackPeriod: null,
      paybackPeriodBeforeTax: null,
      discountedPaybackPeriod: null,
      discountedPaybackPeriodBeforeTax: null,
      利息支出ByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      利息支出Total: 0,
    },
    财务计划现金流量表: {
      operatingCashInflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingCashInflowTotal: 0,
      operatingRevenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingRevenueTotal: 0,
      subsidyIncomeByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      subsidyIncomeTotal: 0,
      operatingOtherCashInflowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      operatingOtherCashInflowTotal: 0,
      operatingCashOutflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingCashOutflowTotal: 0,
      operatingCostByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingCostTotal: 0,
      salesTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      salesTaxTotal: 0,
      vatByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      vatTotal: 0,
      incomeTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      incomeTaxTotal: 0,
      operatingOtherCashOutflowByYear: 0,
      operatingOtherCashOutflowTotal: 0,
      operatingNetCashFlowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingNetCashFlowTotal: 0,
      investmentCashInflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      investmentCashInflowTotal: 0,
      recoveryFixedAssetsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      recoveryFixedAssetsTotal: 0,
      recoveryWorkingCapitalByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      recoveryWorkingCapitalTotal: 0,
      investmentCashOutflowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      investmentCashOutflowTotal: 0,
      constructionInvestmentByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      constructionInvestmentTotal: 0,
      operationMaintenanceInvestmentByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      operationMaintenanceInvestmentTotal: 0,
      workingCapitalByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      workingCapitalTotal: 0,
      investmentOtherCashOutflowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      investmentOtherCashOutflowTotal: 0,
      investmentNetCashFlowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      investmentNetCashFlowTotal: 0,
      financingCashInflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      financingCashInflowTotal: 0,
      equityInvestmentByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      equityInvestmentTotal: 0,
      constructionLoanByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      constructionLoanTotal: 0,
      workingCapitalLoanByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      workingCapitalLoanTotal: 0,
      bondByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      bondTotal: 0,
      shortTermLoanByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      shortTermLoanTotal: 0,
      financingOtherCashInflowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      financingOtherCashInflowTotal: 0,
      financingCashOutflowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      financingCashOutflowTotal: 0,
      利息支出ByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      利息支出Total: 0,
      debtPrincipalRepaymentByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      debtPrincipalRepaymentTotal: 0,
      dividendsByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      dividendsTotal: 0,
      financingOtherCashOutflowByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
      financingOtherCashOutflowTotal: 0,
      financingNetCashFlowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      financingNetCashFlowTotal: 0,
      netCashFlowByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      netCashFlowTotal: 0,
      surplusFundByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      surplusFundTotal: 0,
      cumulativeSurplusFundByYear: [
        0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
      ],
    },
  },
  不确定性分析: {
    sensitivityAnalysis: {
      baseIRR: 0,
      sensitivityTable: [],
      analysisTable: [],
      results: {},
      临界值数量: 0,
      selectedFactors: [],
      changeRateGroup: "1",
    },
    盈亏平衡分析: {
      annualRevenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      salesTaxByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      vatByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      variableCostByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      fixedCostByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      bepUtilizationRateByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      calculationPeriod: 0,
    },
  },
  流动资金估算: {
    计算结果: {
      revenueByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      revenueTotal: 0,
      operatingCostByYear: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      operatingCostTotal: 0,
      receivables: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      inventory: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      cash: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      payables: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      currentAssets: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      currentLiabilities: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      workingCapitalRequirement: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      workingCapitalLoan: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      workingCapitalLoanInterest: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      workingCapitalEquity: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      increaseThisYear: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
      equityIncreaseThisYear: {
        year: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        total: 0,
      },
    },
    revenue: 0,
    operatingCost: 0,
    accountsReceivableTurnover: 9,
    accountsPayableTurnover: 9,
    inventoryTurnover: 9,
    cashTurnover: 18,
    loanRatio: 70,
    loanInterestRate: 5.5,
  },
  investmentEstimate: {
    sensitivityAnalysisData: {
      params: {
        priceChange: 0,
        salesChange: 0,
        rawMaterialChange: 0,
        laborChange: 0,
        fuelPowerChange: 0,
        investmentChange: 0,
      },
      baseData: {
        irr: 0,
        npv: 0,
        annualRevenue: 0,
        annualCost: 0,
      },
      sensitivityResults: {
        price: {
          irrChange: null,
          npvChange: null,
          sensitivityIndex: null,
          changeRate: 0,
        },
        sales: {
          irrChange: null,
          npvChange: null,
          sensitivityIndex: null,
          changeRate: 0,
        },
        rawMaterial: {
          irrChange: 0,
          npvChange: 0,
          sensitivityIndex: 0,
          changeRate: 0,
        },
        labor: {
          irrChange: 0,
          npvChange: 0,
          sensitivityIndex: 0,
          changeRate: 0,
        },
        fuelPower: {
          irrChange: 0,
          npvChange: 0,
          sensitivityIndex: 0,
          changeRate: 0,
        },
        investment: {
          irrChange: 0,
          npvChange: 0,
          sensitivityIndex: 0,
          changeRate: 0,
        },
      },
    },
  },
};

export default jjpj;
